import { render, staticRenderFns } from "./TopUpRequestsSteps.vue?vue&type=template&id=b6b6ffd6"
import script from "./TopUpRequestsSteps.vue?vue&type=script&lang=js"
export * from "./TopUpRequestsSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports